import React, { Component } from 'react';
import Radium from 'radium';
import moment from "moment";

import ArrowLeftImg from "../images/arrow@2x.png";
import ArrowRightImg from "../images/arrow_right@2x.png";

class DaySelector extends Component {

	getDayName() {
		if (this.props.date.isSame(moment(), "day")) {
			return "Today";
		}

		if (this.props.date.isSame(moment().add(-1, "days"), "day")) {
			return "Yesterday";
		}

		if (this.props.date.isSame(moment().add(1, "days"), "day")) {
			return "Tomorrow";
		}

		return this.props.date.format("DD MMM YY");
	}

	renderBubbleName() {
		if (!this.props.selectedBubble) {
			return null;
		}

		return (
			<div style={this.localStyles().bubbleName}>{this.props.selectedBubble.title}</div>
		)
	}

	render() {
		return (
			<div style={this.localStyles().container}>
				<div style={this.localStyles().side} onClick={() => this.props.onChangeDay(-1)}>
					<img alt="Left" src={ArrowLeftImg} style={this.localStyles().arrow}/>
				</div>
				<div style={this.localStyles().headerHolder}>
					<div style={this.localStyles().heading}>
						{this.getDayName()}
						{this.renderBubbleName()}
					</div>
				</div>
				<div style={[this.localStyles().side, this.localStyles().sideRight]} onClick={() => this.props.onChangeDay(1)}>
					<img alt="Right" src={ArrowRightImg} style={[this.localStyles().arrow, this.localStyles().rightArrow]}/>
				</div>
			</div>
		)
	}

	localStyles() {
		return {
			container: {
				marginTop: 20,
				display: "flex",
				flexDirection: "row",
				alignItems: "center",
				width: "100%",
				justifyContent: "space-between",
				userSelect: "none"
			},
			side: {
				paddingLeft: 50
			},
			sideRight: {
				paddingLeft: 0,
				paddingRight: 50
			},
			headerHolder: {
				position: "relative"
			},
			heading: {
				fontSize: 30,
				fontWeight: "700"
			},
			bubbleName: {
				position: "absolute",
				top: 36,
				left: -40,
				right: -40,
				textAlign: "center",
				fontSize: 14,
				fontWeight: "700",
				color: this.props.style.colors.lightText
			},
			arrow: {
				cursor: "pointer",
				width: 18,
				height: 28
			}
		}
	}

}

export default Radium(DaySelector);


// WEBPACK FOOTER //
// ./src/components/DaySelector.js